export default "__VITE_ASSET__DeeH6m8x__"